export default "__VITE_ASSET__DWf3AEMr__"